module.exports = __webpack_public_path__ + "img/422.617defea.jpg";